import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthenticationService } from './services/authentication.service';
import { catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
//import { environment } from 'src/environments/environment';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(private authService:AuthenticationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const skipIntercept =request.headers.get("skip");
    if (!skipIntercept){ // request.headers.has('skip')
      let token=this.authService.userToken;
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          // Prefer:'odata.include-annotations="*"'
          // Prefer:request.method=='POST'?'return=representation':'odata.include-annotations="*"',
          Prefer:(request.method=='POST' || request.method=='PATCH')?'return=representation':'odata.include-annotations="*"',
          'Ocp-Apim-Subscription-Key':  environment.subscriptionKey//'4e46993dd09a4c4db3c9385f9777cb89'
        }
      });
    }
    else{
      request = request.clone({
        headers: request.headers.delete('skip')
      });
    }
      console.log(request);
    return next.handle(request).pipe(
      retry(1),
      catchError(error=>{
        return throwError(error);
      })
    );
  }
}
